/*global chrome*/

import React, { useState, useEffect } from 'react';



import axios from 'axios';
import { getUser, getAccessToken, resetUserSession } from './service/AuthService';
import { setUserGoal } from './service/GoalService';

import AudioRecorder from './AudioRecorder'
import Stopwatch from "./Stopwatch";
import Iframe from './Iframe'
import BrowserNotifications from "./BrowserNotifications";
import './css/Chat.css';
import './css/Loading-Bubbles.css';

import logoIcon from './assets/icon_logo.png';
// import sendBttn from './assets/sendBttn.svg';
import sendBttn from './assets/sendBttnSoft.svg';




// const { Configuration, OpenAIApi } = require("openai");

//TODO: move this to an environment variable

const dailyContentUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/dailyfetch';
const dailySubmitUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/dailysubmit';
const chatURL = 'https://dzustowh5k.execute-api.us-east-1.amazonaws.com/dev/chat'
const fetchConversationURL = 'https://dzustowh5k.execute-api.us-east-1.amazonaws.com/dev/fetchconversation'



// // eslint-disable-next-line no-multi-str
// let template = "yo"

// let treeOfThoughtsTemplate = "Imagine three different experts are answering this question. \
// They will brainstorm the answer step by step reasoning carefully and taking all facts into consideration \
// All experts will write down 1 step of their thinking, \
// then share it with the group. \
// They will each critique their response, and the all the responses of others \
// They will check their answer based on science and the laws of physics \
// Then all experts will go on to the next step and write down this step of their thinking. \
// They will keep going through steps until they reach their conclusion taking into account the thoughts of the other experts \
// If at any time they realise that there is a flaw in their logic they will backtrack to where that flaw occurred \
// If any expert realises they're wrong at any point then they acknowledges this and start another train of thought \
// Each expert will assign a likelihood of their current assertion being correct \
// Continue until the experts agree on the single most likely location \
// The question is {question} \
// The experts reasoning is... \ " 

// // eslint-disable-next-line no-multi-str
// let question = "1. Carlos is at the swimming pool. \
// 2. He walks to the locker room, carrying a towel. \
// 3. He puts his watch in the towel and carries the towel tightly to a lounger at the poolside. \
// 4. At the lounger he opens and vigorously shakes the towel, then walks to the snack bar. \
// 5. He leaves the towel at the snack bar, then walks to the diving board. \
// 6. Later Carlos realises he has has lost his watch. Where is the single most likely location of the watch? "

// let CBTTherapistTemplate = "You are the best cognitive behavioral therapist chat bot in the world. Please help me improve my quality of life in relation to my general mental health and my problematic tech use. Please end your responses with e/" 
// let psychoeducationTutorTemplate = "You are the best cognitive behavioral therapist chat bot in the world. Please help me improve my quality of life in relation to my general mental health and my problematic tech use. Please end your responses with e/" 
// let relapseSupportTemplate = "You are the best cognitive behavioral therapist chat bot in the world. Please help me improve my quality of life in relation to my general mental health and my problematic tech use. Please end your responses with e/" 
// let rapportTemplate = "You are the best cognitive behavioral therapist chat bot in the world. Please help me improve my quality of life in relation to my general mental health and my problematic tech use. Please end your responses with e/" 



// let treeOfThoughts = new PromptTemplate({
//   template: treeOfThoughtsTemplate,
//   inputVariables: ["question"],
// });

// const prePrompt = await chain.call({ input: '' });


const Chat = () => {
    const user = getUser();
    const token = getAccessToken();
    
    const name = user !== 'undefined' && user ? user.name: '';
    const username = user !== 'undefined' && user ? user.username: '';

    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setLoading] = useState(true);
    // const [dailyContent, setDailyContent] = useState('');
    // const [learningContent, setLearningContent] = useState('');
    // const [contentFeedback, setContentFeedback] = useState('');
    // const [dailyLearning, setDailyLearning] = useState('');
    // const [learningFeedback, setLearningFeedback] = useState("Medium");
    // const [dailyPrompt, setDailyPrompt] = useState('');
    // const [promptFeedback, setPromptFeedback] = useState("Medium");
    // const [dailyGoal, setDailyGoal] = useState('');
    // const [goalFeedback, setGoalFeedback] = useState("Medium");
    // const [dailyGoalTitle  , setDailyGoalTitle] = useState('');
    // const [dailyGoalNotification, setDailyGoalNotifications] = useState('');
    // const [morningUse, setMorningUse] = useState('');
    // const [afternoonUse, setAfternoonUse] = useState('');
    // const [nightUse, setNightUse] = useState('');
    // const [currentConfidence, setCurrentConfidence] = useState('');
    // const [yesterdayTakeaways, setYesterdayTakeaways] = useState('');

    // const [prompt, setPrompt] = useState("");
    const [apiResponse, setApiResponse] = useState("");
    const [botLoading, setBotLoading] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [messages, setMessages] = useState([]);

    //messages for the subchats
    const [messagesTherapist, setMessagesTherapist] = useState([]);
    const [messagesDiary, setMessagesDiary] = useState([]);
    const [messagesStress, setMessagesStress] = useState([]);
    const [messagesRelapse, setMessagesRelapse] = useState([]);
    

    const [chatMode, setChatMode] = useState('General: CBT Therapist');

    
    const [audio, setAudio] = useState(null);
    const [audioUrl, setAudioUrl] = useState(null);

    const audioRef = useState(null);

    const [learnPrompts, setLearnPrompts] = useState([]);
    // const [suggestedResponses, setSuggestedResponses] = useState(['General: CBT Therapist', 'Relapse Support', 'Emotional Regulation / Stress Management', 'Support and Check-In / Diary Mode']);

    const [suggestedResponses, setSuggestedResponses] = useState(['Digital Wellness Coach', 'Feeling Overwhelmed', 'Get Back on Track']);
    let suggestions = ['I am feeling overwhelmed ', 'I can not put my phone down', 'I want to improve my sleep quality', 'I feel anxious when I am away from my phone', 'I want to be more present in the moment']
    const [suggestedChatResponses, setSuggestedChatResponses] = useState([]);

    let tempChatMode = 'General: CBT Therapist'

    // const onLearningOptionChange = e => {
    //     setLearningFeedback(e.target.value)
    // }
    // const onPromptOptionChange = e => {
    //     setPromptFeedback(e.target.value)
    // }
    // const onGoalOptionChange = e => {
    //     setGoalFeedback(e.target.value)
    // }

    // function handleAudioState(newValue) {
    //   setAudio(newValue);
    // }

    // function handleAudioUrl(newValue) {
    //   setAudioUrl(newValue);
    // }

    // function randomArrVal(arr){
    //     return arr[Math.floor(Math.random() * arr.length)];
    // }

    // function fetchNextContent(responseObj, progress){
    //     let content = {
    //         'learning': {},
    //         'journal': {},
    //         'goal': {}
    //     };

    //     const dailyPrompt = responseObj['Prompt']
    //     const dailyGoal = responseObj['Goal']
    //     const dailyLearning = responseObj['Learning']
        
    //     const moduleContent = dailyLearning.concat(dailyGoal, dailyPrompt);
        
    //     //console.log('concat', moduleContent)

    //     //TODO: fix the backend so it's changed to content name instead of sk
    //     for (let index = 0; index < moduleContent.length; index++) {
    //         const element = moduleContent[index];
    //         //console.log('element sk', element.sk)
    //         //console.log('element content name', element.contentname)
    //         //console.log('progress sk -- should be content name', progress.learning.sk)
    //         if(element.sk.includes('Learning')){
    //             if(element.contentname === progress.learning.sk){
    //                 content.learning = element
    //             }
    //         }
    //         if(element.sk.includes('Prompt')){
    //             if(element.contentname === progress.journal.sk){
    //                 content.journal = element
    //             }
    //         }
    //         if(element.sk.includes('Goal')){
    //             if(element.contentname === progress.goal.sk){
    //                 content.goal = element
    //             }
    //         }
            
    //     }

    //     return content
    // }

    
    // const LearningSubmitHandler = (event) => {
    //     //console.log('here')
    //     //console.log(audio)

    //     event.preventDefault();
    //     setErrorMessage(null)

    //     const date = new Date().toISOString().slice(0, 10)
        
    //     //TODO: move this to an environment variable
    //     const requestConfig = {
    //         headers: {
    //             'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
    //         }
    //     }

    //     //TODO: make backend changes to make this possible

    //     let progress = dailyLearning.progress + 480
    //     let completed = false
    //     const start = dailyLearning.progress
        
    //     if (progress > dailyLearning.length){
    //         progress = dailyLearning.length
    //         completed = true
    //     }

    //     const requestBody = {
    //         username: username,
    //         token: token,
    //         date: date,
    //         learningContent: {
    //             contentFeedback: contentFeedback,
    //             dailyLearning: dailyLearning,
    //             status: {
    //                 completed: completed,
    //                 start: start,
    //                 progress: progress
    //             }
    //         },
    //         journalContent: {
    //             audio: audio,
    //             dailyPrompt: dailyPrompt
    //         },
    //         goalContent: {
    //             "dailyGoal": dailyGoal,
    //             "selectedGoal": {
    //                 "textcontent": dailyGoalTitle, 
    //                 "notifications": dailyGoalNotification
    //             }
    //         },
    //         morningUse: morningUse,
    //         afternoonUse: afternoonUse,
    //         nightUse: nightUse,
    //         currentConfidence: currentConfidence,
    //         yesterdayTakeaways: yesterdayTakeaways
    //     }



    //     axios.post(dailySubmitUrl, requestBody, requestConfig).then(response => {
    //         setUserGoal({ "textcontent": dailyGoalTitle, "notifications": dailyGoalNotification})
    
    //         //console.log('data submitted')

    //         //console.log('??? submitted')
    //         // setUserSession(response.data.user, response.data.token);
    //         // //console.log(response.data.user)
    //         // //console.log(response.data.user.onboardingComplete)

    //         // if(!response.data.user.onboardingComplete){
    //         //     navigate('/onboarding');
    //         // }
    //         // else{
    //         //     navigate('/premium-content'); 
    //         // }
            
            
    //     }).catch(error => {
    //         //console.log('error')
    //         //console.log(error)
    //         //TODO: fix error of receiving null error
    //         if(error.response.status === 401 || error.response.status === 403 ){
    //             setErrorMessage(error.response.data.message);
    //         }
    //         else{
    //             setErrorMessage('Sorry the server is down. Please try again later.');

    //         }
    //     })
    // }
    // //TODO: move this to an environment variable
    // const requestConfig = {
    //     headers: {
    //         'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
    //     }
    // }

    // const contentParams = {
    //     mode: 'random',
    //     test: 'hi'
    // };

    // const requestBody = {
    //     username: username,
    //     token: token,
    //     contentParams: contentParams,
    // }

    // const timeElapsed = Date.now();
    // const today = new Date(timeElapsed);
    // const todayString = today.toDateString();
 


    ////////////////////////// CHAT

    // function createLearningResponses(){
    //     // let learningKickoff = "Hello Fernando! Here is your daily training session"
    //     let contentFeedback = "What did you think of today's content? Did you find it relevant?"
    //     let learningFeedback = "Will keep that in mind. What personal takeaways did you find?"
    //     let journalPrompt = "How is problematic tech use currently affecting your life?"
    //     let priorDayProgress = "Rate you tech use for the previous day on a scale of 1-10 (1 as in poor 10 as in great)"
    //     let priorDayTakeaways = "What went well and what went poorly from yesterday?"
    //     let todayGoal = "According to your training plan. Today's goal is to make a relapse strategy plan. Want to change it?"
    //     let messageArr = [contentFeedback, learningFeedback, journalPrompt, priorDayProgress, priorDayTakeaways, todayGoal]
    //     let assetArr = [learningContent, '', '', '', '', '', '']
    //     let learningMessages = {
    //         text: messageArr,
    //         assets: assetArr
    //     }
    //     return learningMessages
    // }

    // useEffect(() => {
    //     // do stuff here...
    //     //console.log('fetching conversations in the background')
    //     if (messages.length > 0) {
    //         //console.log('messages array is NOT empty -- no need to fetch them');
    //         return
    //     }
    //     const requestConfig = {
    //         headers: {
    //             'x-api-key': 'o0mDjhG4GZ18ls0RN1iFJ6Z69KRfuWkc3zqRLV0n'
    //         }
    //     }

    //     const requestBody = {
    //         username: username,
    //         token: token,
    //         chatConfig: {
    //             mode: "General: CBT Therapist",
    //             conversation: "General: CBT Therapist",
    //         }
    //     }

    //     axios.post(fetchConversationURL, requestBody, requestConfig).then(response => {
    //         //console.log(response)
    
    //         //console.log('data response: ', response.data)
    //         response = response.data.messages

    //         //console.log("response", response);

    //         // remove the top message
    //         response.shift()

    //         setMessages(response);  
        
    //     }).catch(error => {
    //         //TODO: fix error of receiving null error
    //         //console.log('returned error')
    //         console.error(error);
    // })
    // }, []) 

    function handleInputChange(event) {
        setInputValue(event.target.value);
    }

    function handleLikeDislikeButtonClick(event) {
        event.preventDefault();
        // If the clicked element already has the "active" class, return
        if (event.target.classList.contains('active')) {
        return;
        }

        // Remove the "active" class from all elements with that class
        const activeElements = document.querySelectorAll('.active');
        activeElements.forEach(element => {
            element.classList.remove('active');
        });

        // Add the "active" class to the clicked element
        event.target.classList.add('active');
    };

    // DELETE THIS -- MOVED TO THE API
    // async function handleSendMessage(event) {
    //     //console.log('handle Send Message')
    //     event.preventDefault();
    //     //console.log('input text: ', inputValue)
    //     //console.log('chat mode: ', chatMode)
    //     let response = ''
         
    //     //console.log('audio', audio)
    //     //audio message
    //     if (audio){
    //         // const audioUrl = URL.createObjectURL(audio);
    //         // <div className="audio-container">
    //         //             <audio src={audio} controls></audio>
    //         //             {/* <a download href={audio}>
    //         //                 Download Recording
    //         //             </a> */}
    //         // </div>
    //         //console.log('audio message!!!')
    //         const messageAudio = audioUrl
    //         let newMessage = { audio: messageAudio, isBot: false };
    //         setMessages([...messages, newMessage]);
    //         setAudio(null)
    //         //figure out audio response flow here
    //     }


    //     //text message
    //     if (inputValue.trim() !== '') {
    //         let newMessage = { text: inputValue, isBot: false };
    //         setMessages([...messages, newMessage]);
    //         try {
    //             //console.log('here1')
    //             // const result = await openai.createCompletion({
    //             // model: "text-davinci-003",
    //             // prompt: inputValue,
    //             // temperature: 0,
    //             // max_tokens: 2000,
    //             // });
    //             // let model = new OpenAI({ openAIApiKey: "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", temperature: 0.9 });
    //             //console.log('here2')
    //             const result = await chain.call({ input: inputValue });

    //             //console.log('here3')
    //             //console.log(result)
    //             response = result.response
    //             //console.log("response", response);
    //             setApiResponse(response);
    //         } catch (error) {
    //             //console.log(error);
    //             setApiResponse("Something is going wrong, Please try again.");
    //         }

    //         const botMessage = { text: response, isBot: true };
    //         //console.log('botMessage:', newMessage, botMessage)
    //         setTimeout(() => {
    //             setMessages([...messages, newMessage, botMessage]);  
    //         }, 1000);
    //         setInputValue('');
    //     }
    // }

    async function mlAPIcall(chatObject){
         //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'o0mDjhG4GZ18ls0RN1iFJ6Z69KRfuWkc3zqRLV0n'
            }
        }

        const date = new Date().toISOString().slice(0, 10)

        const requestBody = {
            username: username,
            token: token,
            date: date,
            chatConfig: {
                mode: 'default',
            },
            input: {"question": chatObject.input},
        }

        axios.post(chatURL, requestBody, requestConfig).then(response => {
            //console.log(response)
    
            //console.log('data response: ', response.data)
            return response.data
            
        }).catch(error => {
            //console.log('error')
            //console.log(error)
            //TODO: fix error of receiving null error
            if(error.response.status === 401 || error.response.status === 403 ){
                setErrorMessage(error.response.data.message);
            }
            else{
                setErrorMessage('Sorry the server is down. Please try again later.');

            }
        })
    }

    async function handleSendMessage(event) {
        // console.log('handle Send Message')
        event.preventDefault();
        // console.log('input text: ', inputValue)
        // console.log('chat mode: ', chatMode)
        //console.log('temp chat mode: ', tempChatMode)
        let response = ''
         
        //console.log('audio', audio)
        //audio message
        if (audio){
            // const audioUrl = URL.createObjectURL(audio);
            // <div className="audio-container">
            //             <audio src={audio} controls></audio>
            //             {/* <a download href={audio}>
            //                 Download Recording
            //             </a> */}
            // </div>
            //console.log('audio message!!!')
            const messageAudio = audioUrl
            let newMessage = { audio: messageAudio, isBot: false };
            setMessages([...messages, newMessage]);
            setAudio(null)
            //figure out audio response flow here
        }


        //text message
        if (inputValue.trim() !== '') {
            let newMessage = { text: inputValue, isBot: false };
            setMessages([...messages, newMessage]);
            //console.log("sent out a chat message")
            try {
                 const requestConfig = {
                    headers: {
                        'x-api-key': 'o0mDjhG4GZ18ls0RN1iFJ6Z69KRfuWkc3zqRLV0n'
                    }
                }

                const date = new Date().toISOString()

                const requestBody = {
                    username: username,
                    token: token,
                    time: date,
                    chatConfig: {
                        mode: chatMode,
                        conversation: chatMode,
                    },
                    input: {"question": inputValue},
                }

                //console.log('requestBody. pre message: ', requestBody)

                axios.post(chatURL, requestBody, requestConfig).then(response => {
                    //console.log(response)
            
                    //console.log('data response: ', response.data)
                    response = response.data.response

                    //console.log("response", response);
                    setApiResponse(response);
                    const botMessage = { text: response, isBot: true };
                    //console.log('botMessage:', newMessage, botMessage)
                    //console.log('last message', messages[-1])
                    setMessages([...messages, newMessage, botMessage]);
                    setInputValue('');
                    
                }).catch(error => {
                    //console.log('error')
                    //console.log(error)
                    //TODO: fix error of receiving null error
                    if(error.response.status === 401 || error.response.status === 403 ){
                        setErrorMessage(error.response.data.message);
                    }
                    else{
                        setErrorMessage('Sorry the server is down. Please try again later.');

                    }
                })

            } catch (error) {
                //console.log(error);
                setApiResponse("Something is going wrong, Please try again.");
            }

            const botMessage = { text: response, isBot: true };
            //console.log('botMessage:', newMessage, botMessage)
            setTimeout(() => {
                setMessages([...messages, newMessage, botMessage]);  
            }, 1000);
            setInputValue('');
        }
    }
    
    //TODO: need to update this
    
    async function handleButtonClicked(buttonText) {
        //console.log('here')
        document.getElementById('CBTexercises').style.display = 'none'
        document.getElementById('chatWelcome').style.display = 'none'
        //console.log('exercises invisible')

        // console.log('buttonText: ', buttonText);
        //console.log('chatMode: ', chatMode)
        // if (buttonText === chatMode){
        //     //console.log('messages already loaded')
        //      setTimeout(() => {
        //         document.getElementById('messagesContainer').style.display = 'block' 
        //     }, 1000);
        //     return
        // }

        if (messages.length > 0) {
            //console.log('messages already loaded')
            return
        }
        tempChatMode = buttonText
        setChatMode(buttonText);
        
        const loadingSpinner = document.querySelector('.donut');
        
        if (loadingSpinner) {
            loadingSpinner.style.display = 'inline-block'; // Example: Change the text color
        }
        
        let response = []
        try {

            const requestConfig = {
                headers: {
                    'x-api-key': 'o0mDjhG4GZ18ls0RN1iFJ6Z69KRfuWkc3zqRLV0n'
                }
            }

            const requestBody = {
                username: username,
                token: token,
                chatConfig: {
                    mode: buttonText,
                    conversation: buttonText,
                }
            }

            console.log('requestBody: ', requestBody)

            axios.post(fetchConversationURL, requestBody, requestConfig).then(response => {
                //console.log(response)
        
                //console.log('data response: ', response.data)
                response = response.data.messages

                //console.log("response", response);

                // remove the top message
                response.shift()
                if (loadingSpinner) {
                    loadingSpinner.style.display = 'none'; // Example: Change the text color
                }
                // setTimeout(() => {
                //     //console.log('Hello, world!');
                // }, 500);  

                setMessages(response);  
                
            }).catch(error => {
                //console.log('error')
                //console.log(error)
                //TODO: fix error of receiving null error
                if(error.response.status === 401 || error.response.status === 403 ){
                    setErrorMessage(error.response.data.message);
                }
                else{
                    setErrorMessage('Sorry the server is down. Please try again later.');

                }
            })

        } catch (error) {
            //console.log(error);
            setApiResponse("Something is going wrong, Please try again.");
        }
        
        setMessages(response);  

        

        // if(buttonText === 'Support and Check-In / Diary Mode'){
        //     //TODO: change background
        //     //TODO: save messages to variable
        //     // setChatMessages(messages)
        //     //clear messages and create kick off message
        //     //TODO: un hard code this below
        //     //console.log('1')
        //     newMessage = { text: "I'm here to provide a safe space for you to express yourself and track your progress. Please feel free to share any thoughts or experiences related to your problematic tech use and how you're feeling today.", isBot: true }
        //     setMessages([newMessage])
        //     //Pre prompt
        //     let CBTTherapistTemplate = "You are the best cognitive behavioral chatbot in the world. You are assisting a client who is struggling with problematic tech use and is looking for mental health support. Do not ask a question on all your responses. Please end your responses with e/. A user just clicked on Support and Check-In / Diary Mode." 
        //     // const result = await chain.call({ input: CBTTherapistTemplate });

        // }
        // else if (buttonText === 'Emotional Regulation / Stress Management'){
        //     //TODO: change the code below it's hideous. need to gigure out how to make sure that everything is on chat mode and guided as well
        //     setChatMode(chatMode);
    
        //     newMessage = { text: "I'm here to help you develop effective strategies to cope with stress and manage your emotions when facing problematic tech use. Let's explore techniques like deep breathing, mindfulness, and grounding exercises to regain control and find balance in your digital life.", isBot: true }
        //     //console.log('2')
        //     setMessages([newMessage])
        //     let CBTTherapistTemplate = "You are the best cognitive behavioral chatbot in the world. You are assisting a client who is struggling with problematic tech use and is looking for mental health support. Do not ask a question on all your responses. Please end your responses with e/. A user just clicked on Emotional Regulation / Stress Management Mode." 
        //     // const result = await chain.call({ input: CBTTherapistTemplate });

        // }
        // else if (buttonText === 'Relapse Support'){
        //     setChatMode(chatMode);
        //     newMessage = { text: "Remember, setbacks are a natural part of the recovery process. It's essential not to be too hard on yourself. Let's identify any triggers or stressors that may have contributed to the relapse and work together on developing a plan to bounce back stronger.", assets: learningContent, isBot: true }
        //     //console.log('3')
        //     setMessages([newMessage])
        //     let CBTTherapistTemplate = "You are the best cognitive behavioral chatbot in the world. You are assisting a client who is struggling with problematic tech use and is looking for mental health support. Do not ask a question on all your responses. Please end your responses with e/. A user just clicked on Relapse Support mode." 
        //     // const result = await chain.call({ input: CBTTherapistTemplate });
        // }
        // else if (buttonText === 'General: CBT Therapist'){
        //     //TODO: change the code below it's hideous. need to gigure out how to make sure that everything is on chat mode and guided as well
        //     setChatMode(chatMode);
    
        //     newMessage = { text: "Good afternoon. How are you feeling today? What do you want to talk about?", isBot: true }
        //     //console.log('4')
        //     setMessages([newMessage])
        //     // let CBTTherapistTemplate = "You are the best cognitive behavioral chatbot in the world. You are assisting a client who is struggling with problematic tech use and is looking for mental health support. Do not ask a question on all your responses. Please end your responses with e/. You just started your session by saying: Good morning. How are you feeling today? What do you want to talk about?" 
        //     let CBTTherapistTemplate = "You are the best cognitive behavioral therapist in the world. You are assisting a client who is struggling with problematic tech use and is looking for mental health support. Please end your responses with e/." 

        //     // const result = await chain.call({ input: CBTTherapistTemplate });

        // }

        // // setPastChatMode(chatMode);
        // // const newMessage = { text: buttonText, isBot: false };
        // // setMessages([...messages, newMessage]);
        // // //console.log(learnResponses)
        // // let response = learnResponses[learnState]
        // // const botMessage = { text: response, isBot: true };
        // // //console.log('botMessage:', newMessage, botMessage)
        // // setTimeout(() => {
        // //     setMessages([...messages, newMessage]);  
        // // }, 1000);
        // setInputValue('');

        // // setTimeout(() => {
        // //         document.getElementById('CBTexercises').style.display = 'none'
        // // }, 200);
    }

//console.log('journal audio',audio)
//console.log('journal audio URL',audioUrl)
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', alignItems: 'center', marginLeft: '1.5rem', marginRight:' 1.5rem', marginTop: '3.5rem' }}>
        <div className="donut"></div>
        <div id="chatWelcome">
            {/* <h1 style={{ textAlign:'center' }}>Welcome Back {username}</h1> */}
            <h5 style={{ marginTop:'-3rem', textAlign: 'center' }}>Need some motivation, feel stuck or alone, or simply want to talk?</h5>
        </div>
        {/* <div
                key={0}
                style={{
                alignSelf: true ? 'flex-start' : 'flex-end',
                backgroundColor: '#EEE',
                borderRadius: '5px',
                color: '#000',
                margin: '10px',
                maxWidth: '60%',
                padding: '10px',
                wordWrap: 'break-word',
                fontSize: '0.875em'
                }}
            >
                Hello Fernando! Here is your daily training session 😊. It will help you make the most out of Trampoline Health. Let me know what you think? Do you find it relevant?
                <p></p>;;;

                {learningContent}
            </div> */}
        
        <div id="messagesContainer">
            <div style={{ flex: 1, overflowY: 'auto',  maxWidth:'500px' }}>
                {messages.map((message, index) => (

                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <div className="logo">
                        <img style={{ width: '35px', height: '35px', paddingTop: '0.5rem', display: message.isBot ? 'block' : 'none' }} src={logoIcon} alt="Example" />
                        <div
                            className="chat-circle"
                            style={{
                                display: message.isBot ? 'none' : 'flex',
                                background: 'rgba(255, 255, 255, 0.12)',
                                border: '1px solid rgba(255, 255, 255, 0.24)',
                                color: 'rgba(255, 255, 255, 0.9)',
                                fontFamily: "'DM Sans', sans-serif",
                                fontWeight: 600,
                            }}
                        >
                            {name[0].toUpperCase()}
                        </div>
                    </div>
                    <div
                        key={index}
                        style={{
                        alignSelf: message.isBot ? 'flex-start' : 'flex-end',
                        background: message.isBot
                            ? 'linear-gradient(160deg, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.04))'
                            : 'linear-gradient(160deg, rgba(84, 154, 204, 0.36), rgba(84, 154, 204, 0.2))',
                        border: message.isBot
                            ? '1px solid rgba(255, 255, 255, 0.16)'
                            : '1px solid rgba(180, 222, 255, 0.36)',
                        borderRadius: '16px',
                        color: 'rgba(255, 255, 255, 0.9)',
                        margin: '10px',
                        maxWidth: '75%',
                        padding: '12px 14px',
                        wordWrap: 'break-word',
                        fontFamily: "'DM Sans', sans-serif",
                        fontSize: '0.92rem',
                        lineHeight: 1.5,
                        boxShadow: '0 10px 20px rgba(4, 8, 16, 0.18)',
                        }}
                    >
                        {message.text}
                        {message.assets}
                        {message.audio && (
                            <audio style={{ width: '100%'}} controls ref={audioRef}>
                                <source src={message.audio} type="audio/wav" />
                                Your browser does not support the audio element.
                            </audio>
                        )}
                        <div class="loader"  style={{ display: message.isBot ? 'flex' : 'none', visibility: message.text ? 'hidden': 'visible' }}>
                            <div class="bubble"></div>
                            <div class="bubble"></div>
                            <div class="bubble"></div>
                            <div class="bubble"></div>
                        </div>
                        <div className="rating" style={{ display: 'none', flexDirection: 'row', height: '100%', alignItems: 'center'}}>
                            <div className="like" style={{ height: '100%', alignItems: 'center', padding:'0.5rem', display: message.isBot ? 'block' : 'none' }}>
                                <i className="fa fa-thumbs-up fa-1x like" aria-hidden="true" onClick={handleLikeDislikeButtonClick}></i>
                            </div>
                            <div className="dislike" style={{ height: '100%', alignItems: 'center', padding:'0.5rem', display: message.isBot ? 'block' : 'none' }}>
                                <i className="fa fa-thumbs-down fa-1x like" aria-hidden="true" onClick={handleLikeDislikeButtonClick}></i>
                            </div>
                        </div>
                    </div>
                </div>

                ))}
            </div> 
            <div style={{ padding: '1rem' }}></div>    
        </div>
       
        <div style={{ position: 'absolute', bottom: '7.5rem', width: '100%',  maxWidth:'500px', fontSize: '0.875em' }}>
            <div id="CBTexercises" style={{ display: 'flex', justifyContent: 'center', padding: '2.5rem', flexDirection: 'column'}}>
                {suggestedResponses.map((response, index) => (
                <button
                    key={index}
                    onClick={() => handleButtonClicked(response)}
                    style={{
                        width: '100%',
                        margin: '0 0 12px',
                        padding: '16px 24px',
                        background: 'transparent',
                        border: '1px solid rgba(255, 255, 255, 0.45)',
                        borderRadius: '50px',
                        fontFamily: "'DM Sans', sans-serif",
                        fontSize: '15px',
                        fontWeight: 500,
                        color: '#ffffff',
                        letterSpacing: '0.3px',
                        boxShadow: 'none',
                    }}
                    className="button arrow homeBttn chatOptionBttn"
                    type="button"
                >
                    {response}
                </button>
                ))}
            </div>
            {/* <form onSubmit={handleSendMessage} style={{ display: 'flex', width: '94%', fontSize: '0.875em', justifyContent: 'center' }}>
                {!audio ? (
                    <input
                        type="text"
                        value={inputValue}
                        onChange={handleInputChange}
                        style={{ flex: 1, marginRight: '10px', padding: '15px' }}
                    />
                ) : null}
                <input
                    type="text"
                    value={inputValue}
                    onChange={handleInputChange}
                    style={{ flex: 1, marginRight: '1rem', padding: '15px', marginLeft: '2.5rem' }}
                />
                <div> <AudioRecorder saveAudioBlob= {handleAudioState} saveAudio= {handleAudioUrl} audio = { audioUrl } /> </div> 
                <button type="submit" style={{ padding: '15px', color: '#4490C3', backgroundColor:'#FBF4CD' }}>Send</button>
            </form> */}
        </div>
        {/* <div style={{ position: 'absolute', bottom: '0rem', width: '100%', fontSize: '0.875em', paddingBottom: '4.5rem', paddingTop: '1rem', background: 'linear-gradient(#86b7e7, #EFEEED)' }}> */}        
        <div style={{boxSizing: 'border-box', left: '0', right: '0', margin: '0 auto', position: 'absolute', bottom: '0rem', width: '100%', maxWidth:'500px', fontSize: '0.875em', paddingBottom: '2.0rem', paddingTop: '2rem', background: 'white' }}>
            <div id="chatSuggestions" style={{ display: 'none', justifyContent: 'center', padding: '2.5rem', flexDirection: 'row' }}>
                {suggestedChatResponses.map((response, index) => (
                <button
                    key={index}
                    onClick={() => handleButtonClicked(response)}
                    style={{ marginRight: '10px', padding: '1rem' }}
                    type="button"
                >
                    {response}
                </button>
                ))}
            </div>
            <form onSubmit={handleSendMessage} style={{ display: 'flex', width: '94%', fontSize: '0.875em', justifyContent: 'center' }}>
                {/* {!audio ? (
                    <input
                        type="text"
                        value={inputValue}
                        onChange={handleInputChange}
                        style={{ flex: 1, marginRight: '10px', padding: '15px' }}
                    />
                ) : null} */}
                {/* <textarea
                    id="prompt-textarea" 
                    rows={1}
                    placeholder="Send a message" 
                    value={inputValue}
                    onChange={handleInputChange}
                    style={{ flex: 1, marginRight: '1rem', padding: '15px', marginLeft: '2.5rem', maxHeight: '200px', height: '96px', overflowY: 'hidden', fontSize: '16px' }}
                /> */}
                <input
                    type="text"
                    value={inputValue}
                    onChange={handleInputChange}
                    style={{ flex: 1, marginRight: '1rem', padding: '15px', marginLeft: '2.5rem', overflowX: 'auto', fontSize: '16px', borderRadius: '10px', border: '1px solid #000', width: '65%', maxHeight: '52px', overflowY: 'auto' }}
                />
                {/* <div 
                    contenteditable="true"
                    style={{ flex: 1, marginRight: '1rem', padding: '15px', marginLeft: '2.5rem', fontSize: '16px', borderRadius: '10px', border: '1px solid #000', width: '65%', maxHeight: '52px', overflowY: 'auto'}}>
                </div> */}
                {/* <div> <AudioRecorder saveAudioBlob= {handleAudioState} saveAudio= {handleAudioUrl} audio = { audioUrl } /> </div>  */}
                <button type="submit" style={{ padding: '15px', color: '#black', backgroundColor:'#EFEEED', height: '60px' }}><img src={sendBttn} style={{height:'25px', width:'25px'}} alt="sendBttn" /></button>
            </form>
    </div>
        
    </div>
  );
}

export default Chat;